import { gql } from "apollo-boost"

export const upsertComments = gql`
  mutation UpsertComments($data: [CreateCommentInput!]!){
    UpsertComments(data: $data)
  }
`
